import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit';
import { toast } from 'sonner';

import { HttpStatuses } from '@shared/types/enums/http.enum';
import { getClientId } from '@shared/utils/getClientId/getClientId';

import {
  CreateBankPaymentRequest,
  createOrderBankPayment,
  createOrderYandexPayment,
  CreateOrderYandexPaymentRequest
} from '../../';

const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator }
});

const initialState = {};

export const placingOrderSlice = createAppSlice({
  name: 'placingOrder',
  initialState,
  reducers: (create) => ({
    createOrderBankThunk: create.asyncThunk(async (params: Omit<CreateBankPaymentRequest, 'clientId'>, thunkAPI) => {
      const clientId = await getClientId();

      const data = await createOrderBankPayment({ clientId, ...params });
      if (data.data?.status) {
        return thunkAPI.rejectWithValue(HttpStatuses.ERROR);
      }

      return data.data;
    }),
    createOrderYandexPaymentThunk: create.asyncThunk(
      async (params: Omit<CreateOrderYandexPaymentRequest, 'clientId'>, thunkAPI) => {
        const clientId = await getClientId();

        const data = await createOrderYandexPayment({ clientId, ...params });

        if (data.data?.status !== HttpStatuses.SUCCESS) {
          return thunkAPI.rejectWithValue(HttpStatuses.ERROR);
        }

        return data.data;
      },
      {
        rejected: () => {
          toast('Ошибка при создании заказа', {
            duration: 2000,
            position: 'top-right',
            style: {
              textAlign: 'center',
              color: '#ffffff',
              backgroundColor: '#ef4444',
              border: 'none'
            }
          });
        }
      }
    )
  })
});

export const { createOrderBankThunk, createOrderYandexPaymentThunk } = placingOrderSlice.actions;

export const placingOrderReducer = placingOrderSlice.reducer;
